import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LockIcon, ChevronDownIcon } from 'lucide-react';
import { SolutionsMenu } from './SolutionsMenu';
import { ResourcesMenu } from './ResourcesMenu';
import { usePostHog } from 'posthog-js/react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const location = useLocation();
  const posthog = usePostHog();
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close menu on route change
  useEffect(() => {
    setSolutionsOpen(false);
    setResourcesOpen(false);
  }, [location.pathname]);
  const handlePricingClick = () => {
    posthog.capture('pricing_clicked', {
      source: 'navbar'
    });
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-navy/90 backdrop-blur-xl border-b border-white/5' : 'bg-transparent'}`} data-id="element-215">

      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between relative" data-id="element-216">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5 z-50" data-id="element-217">
          <img src="https://thruline-public.s3.us-west-1.amazonaws.com/brand/logos/png/logo-dark-trans.png" alt="Thruline" className="h-14 w-auto" data-id="element-218" />

        </Link>

        {/* Center Links */}
        <div className="hidden md:flex items-center gap-8 h-full" data-id="element-219">
          {/* Solutions Dropdown */}
          <div className="relative h-full flex items-center" onMouseEnter={() => {
          setSolutionsOpen(true);
          setResourcesOpen(false);
        }} onMouseLeave={() => setSolutionsOpen(false)} data-id="element-220">

            <button className={`flex items-center gap-1 text-sm font-medium transition-colors ${solutionsOpen ? 'text-white' : 'text-white/70 hover:text-white'}`} data-id="element-221">

              Solutions
              <ChevronDownIcon className={`w-3 h-3 transition-transform duration-200 ${solutionsOpen ? 'rotate-180' : ''}`} data-id="element-222" />

            </button>

            {solutionsOpen && <SolutionsMenu onClose={() => setSolutionsOpen(false)} data-id="element-223" />}
          </div>

          <Link to="/pricing" onClick={handlePricingClick} className="text-white/70 hover:text-white text-sm font-medium transition-colors" data-id="element-224">

            Pricing
          </Link>

          {/* Resources Dropdown */}
          <div className="relative h-full flex items-center" onMouseEnter={() => {
          setResourcesOpen(true);
          setSolutionsOpen(false);
        }} onMouseLeave={() => setResourcesOpen(false)} data-id="element-225">

            <button className={`flex items-center gap-1 text-sm font-medium transition-colors ${resourcesOpen ? 'text-white' : 'text-white/70 hover:text-white'}`} data-id="element-226">

              Resources
              <ChevronDownIcon className={`w-3 h-3 transition-transform duration-200 ${resourcesOpen ? 'rotate-180' : ''}`} data-id="element-227" />

            </button>

            {resourcesOpen && <ResourcesMenu onClose={() => setResourcesOpen(false)} data-id="element-228" />}
          </div>
        </div>

        {/* CTAs */}
        <div className="flex items-center gap-3 z-50" data-id="element-229">
          <a href="https://app.thruline.co/non-auth/signup" className="hidden sm:inline-flex items-center px-5 py-2 rounded-full bg-white text-navy font-semibold text-sm hover:bg-white/90 transition-colors" data-id="element-230">

            Sign up for free
          </a>
          <a href="https://app.thruline.co/" className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-white/30 text-white font-medium text-sm hover:border-white/60 transition-colors" data-id="element-231">

            <LockIcon className="w-3.5 h-3.5" data-id="element-232" />
            Login
          </a>
        </div>
      </div>
    </nav>;
}